import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  FieldHeader,
  FieldBody,
} from 'web-ui-components/lib/molecules/forms';
import { CurrencySelect } from 'web-ui-components/lib/finance/currency';
import { Callout } from 'web-ui-components/lib/atoms/text';

export const NotionalCurrencySelect = ({
  name,
  title,
  currencies,
  selectedId,
  validationMessage,
  onCurrencySelect,
}) => (
  <Field>
    <FieldHeader
      name={name}
      title={title}
      validationMessage={validationMessage}
      hasError={!!validationMessage}
    />
    <FieldBody>
      <Callout>
        <CurrencySelect
          currencies={currencies}
          selectedId={selectedId}
          onChange={(id) => onCurrencySelect(id)}
        />
      </Callout>
    </FieldBody>
  </Field>
);

NotionalCurrencySelect.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  validationMessage: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};
